/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Row, Col, Container } from 'reactstrap';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import * as environment from '../../../modules/environment';
import {connect} from "react-redux";


class ProvidersItems extends PureComponent {
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.shape({
            src: PropTypes.string,
            title: PropTypes.string,
            price: PropTypes.string,
            description: PropTypes.string,
            colors: PropTypes.arrayOf(PropTypes.string),
            new: PropTypes.bool,
        })),
    };

    static defaultProps = {
        items: [],
    };

    render() {

        //console.log(this.props.items);

        let cellular = this.props.items.filter(a => a.providerType === 1);
        let cellularKasher = this.props.items.filter(a => a.providerType === 4);

        //console.log(cellular012);

        return (
            <Container className="catalog-items__wrap">
                {/*Cellular Regular + 012*/}
                {cellular && cellular.length > 0 && <Row style={{ fontSize: '30px'}}>סלולר רגיל</Row>}
                {cellular && cellular.length > 0 && <Row>
                    <div className="catalog-items">
                        {this.props.items.filter(a => (a.providerType === 1 && a.id !== 8)).map((item, i) =>
                            (

                                <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px', backgroundColor: 'aliceblue' }}>
                                    <p className="catalog-item__link" style={{cursor: 'pointer'}} onClick={() => this.props.chooseProvider(item.id, item.name)}>
                                        <div className="catalog-item__info">
                                            <h5 className="catalog-item__title" style={{fontWeight: 'bold', textAlign: 'center'}}>{item.name}</h5>
                                        </div>
                                        <div className="catalog-item__img-wrap">
                                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                 src={environment.getServerBasePath() + '/api/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                        </div>
                                    </p>
                                </Col>

                            ))}
                    </div>
                </Row>}

                {/*Cellular Kasher*/}
                {cellularKasher && cellularKasher.length > 0 && <Row style={{ fontSize: '30px'}}>סלולר כשר</Row>}
                {cellularKasher && cellularKasher.length > 0 && <Row>
                    <div className="catalog-items">
                        {this.props.items.filter(a => a.providerType === 4).map((item, i) =>
                            (

                                <Col xs={5} md={1} className="catalog-item" key={i} style={{ marginBottom: '5px', marginRight: '3px', marginLeft: '3px', backgroundColor: 'aliceblue' }}>
                                    <p className="catalog-item__link" style={{cursor: 'pointer'}} onClick={() => this.props.chooseProvider(item.id, item.name)}>
                                        <div className="catalog-item__info">
                                            <h5 className="catalog-item__title" style={{fontWeight: 'bold', textAlign: 'center'}}>{item.name}</h5>
                                        </div>
                                        <div className="catalog-item__img-wrap">
                                            <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                                 src={environment.getServerBasePath() + '/api/providers/download?providerID=' + item.id} alt="catalog-item-img" />
                                        </div>
                                    </p>
                                </Col>

                            ))}
                    </div>
                </Row>}

            </Container>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(ProvidersItems))
